export enum ErrorMessage {
  badCredentials,
  blacklist,
  ipBlacklist,
  disabled,
  noRedirectUrl,
  noClient,
  other,
}
